export enum FeedbackListSort {
  SOLVED_AT = 'solvedAt',
}
export enum FeedbackListFilter {
  IS_CHECK = 'isCheck',
  MATERIAL_COURSE = 'materialCourse',
  MATERIAL_TYPE = 'materialType',
}

export const FeedbackListColumn = {
  MISSION_TITLE: 'missionTitle',
  PROBLEM_NUMBER: 'problemNumber',
  IS_CHECK: FeedbackListFilter.IS_CHECK,
  MATERIAL_COURSE: FeedbackListFilter.MATERIAL_COURSE,
  MATERIAL_TYPE: FeedbackListFilter.MATERIAL_TYPE,
  SOLVED_AT: FeedbackListSort.SOLVED_AT,
} as const;
